import type { ReactNode } from "react";

import classNames from "classnames";

import styles from "./TabSelector.module.scss";

export type TabSelectorProps = {
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  size?: "small" | "large";
  onClick?: () => void;
  className?: string;
  role?: string;
};

export const TabSelector = ({
  active = false,
  onClick,
  children,
  size = "large",
  disabled = false,
  className,
}: TabSelectorProps) => {
  return (
    <button
      className={classNames(
        styles.tabSelector,
        styles[size],
        { [styles.active]: active, [styles.disabled]: disabled },
        className
      )}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {children}
    </button>
  );
};
